import React from "react";
import Joi from "joi-browser";
import uuid from "react-uuid";
import { toast } from "react-toastify";
import { Tabs, Tab } from "react-bootstrap";
import {
  getRole,
  getParentRoles,
  addRole,
  updateRole,
} from "../../../common/services/auth/roleService";
import ChildRoles from "./childRoles";
import Form from "../../../common/components/form/form";
import Loading from "../../../common/components/loading/loading";
import RoleHistory from "./roleHistory";
import { withTranslation } from "react-i18next";
import RoleUserAccounts from "./roleUserAccounts";

class Role extends Form {
  state = {
    data: {
      roleId: "",
      name: "",
      description: "",
      eventId: "",
    },
    createdDate: "",
    updatedDate: "",
    errors: {},
    isLoading: true,
    isNew: true,
  };

  schema = {
    roleId: Joi.string(),
    name: Joi.string().required().label(this.props.t("RoleName")),
    description: Joi.string().required().label(this.props.t("RoleDescription")),
    active: Joi.boolean().label(this.props.t("Active")),
    eventId: Joi.string(),
  };

  async componentDidMount() {
    //try{
    const { roleId, isNew } = this.props;
    this.setState({ isNew: isNew });
    var role = {};

    const parentRoles = await getParentRoles();
    const isParent = parentRoles.filter((x) => x.roleId === roleId).length > 0;

    if (!isNew) {
      role = await getRole(roleId);
      role.eventId = uuid();
    } //New User Add
    else {
      role = {
        roleId: roleId,
        name: "",
        description: "",
        active: true,
        eventId: uuid(),
      };
    }
    this.setState({
      data: this.mapToViewModel(role),
      isParent: isParent,
      isLoading: false,
    });

    const dateFormatOptions = {
      year: "numeric",
      month: "2-digit",
      day: "numeric",
      hour: "numeric",
      hour12: false,
      minute: "numeric",
      second: "numeric",
    };

    this.setState({
      createdDate: new Date(role.createdDate).toLocaleDateString(
        "en-US",
        dateFormatOptions
      ),
      updatedDate: new Date(role.updatedDate).toLocaleDateString(
        "en-US",
        dateFormatOptions
      ),
    });
    // }
    // catch(ex)
    // {
    //     //Handle Erorr..
    // }
  }

  mapToViewModel(role) {
    return {
      roleId: role.roleId,
      name: role.name,
      description: role.description,
      active: role.active,
      eventId: role.eventId,
    };
  }

  doSubmit = async () => {
    const { t, onRename } = this.props;
    const { isNew } = this.state;

    try {
      //Reset the event ID
      const data = { ...this.state.data };
      data.eventId = uuid();

      this.setState({ data: data });

      if (!isNew) {
        await updateRole(this.state.data);
        toast.success(t("RoleUpdated"));
      } else {
        await addRole(this.state.data);
        this.setState({ isNew: false });
        onRename(this.state.data.roleId, this.state.data.name);
        toast.success(t("RoleAdded"));
      }

      //Call back to the select list to allow it to update.
      this.props.submitCallbackFunction(this.state.data);
    } catch (ex) {
      console.log(t("ErrorSaving"), ex);

      if (ex.response && ex.response.status === 400) {
        var errorList = ex.response.data.errors;
        if (errorList) {
          var errorKeys = Object.keys(ex.response.data.errors);
          errorKeys.forEach(function (key) {
            errorList[key].map((error) => {
              toast.error(t("ErrorSaving") + " " + key + ": " + error);
              return null;
            });
          });
        } else {
          toast.error(t("ErrorSaving") + " " + ex.response.data);
        }
        const errors = { ...this.state.errors };
        errors.Name = ex.response.data;
        toast.error(ex.response.data.errors.title);
        this.setState({ errors });
      }
    }
  };

  render() {
    const { isLoading, isNew, createdDate, updatedDate, isParent } = this.state;

    if (isLoading) return <Loading />;

    const { t, roleId, allowEdit } = this.props;

    return (
      <div className="container-fluid">
        <form className="form-inline" onSubmit={this.handleSubmit}>
          <fieldset disabled={allowEdit ? "" : "disabled"}>
            <div>
              {this.renderSwitch("active", t("Active"))}
              {isNew
                ? this.renderInput("name", t("RoleName"))
                : this.renderDisabledInput("name", "RoleName")}
              {this.renderInput("description", t("RoleDescription"))}
              {allowEdit && this.renderButton(t("Save"))}
              <div className="form-footnote">
                {createdDate !== "Invalid Date" && (
                  <div>
                    {t("Created")} {createdDate}
                  </div>
                )}
                {updatedDate !== "Invalid Date" && (
                  <div>
                    {t("Updated")} {updatedDate}
                  </div>
                )}
              </div>
            </div>
          </fieldset>
        </form>
        {!isNew && (
          <div>
            <Tabs
              className="nav-dark nav-tabs-sm"
              defaultActiveKey={isParent ? 1 : 3}
              id="useraccount-tabs"
              mountOnEnter={true}
              unmountOnExit={true}
            >
              {isParent && (
                <Tab eventKey={1} title={t("ChildRoles")}>
                  <ChildRoles roleId={roleId} allowEdit={allowEdit} />
                </Tab>
              )}
              {isParent && (
                <Tab eventKey={2} title={t("UserAccounts")}>
                  <RoleUserAccounts roleId={roleId} allowEdit={allowEdit} />
                </Tab>
              )}
              <Tab eventKey={3} title={t("History")}>
                <RoleHistory roleId={roleId} />
              </Tab>
            </Tabs>
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation(["auth"])(Role);
